import React from 'react';

import { Field } from 'react-final-form';
import { NamedLink } from '../../../components';
import { FormattedMessage, intlShape } from '../../../util/reactIntl';

import css from './TermsAndConditions.module.css';

const IconCheckbox = ({ checked }) => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
    <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3.25" fill="white" />
    <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3.25" stroke="#B0B0B5" strokeWidth="1.5" fill="none" />
    {checked && (
      <>
        <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3.25" fill="#F85757" fillOpacity="0.05" />
        <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3.25" stroke="#F85757" strokeWidth="1.5" fill="none" />
        <path d="M12 5L6.5 10.5L4 8" stroke="#F85757" strokeWidth="1.6666" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </>
    )}
  </svg>
);

const TermsAndConditions = props => {
  const { intl } = props;

  const errorMessage = intl.formatMessage({
    id: 'AuthenticationPage.termsAndConditionsAcceptRequired',
  });

  const validate = value => {
    return Array.isArray(value) && value.includes('tos-and-privacy') ? undefined : errorMessage;
  };

  return (
    <div className={css.root}>
      <Field name="terms" validate={validate}>
        {({ input, meta }) => {
          const isChecked = Array.isArray(input.value) && input.value.includes('tos-and-privacy');

          const toggle = () => {
            input.onChange(isChecked ? [] : ['tos-and-privacy']);
            input.onBlur();
          };

          return (
            <div>
              <div className={css.checkboxRow}>
                <span className={css.checkboxIcon} onClick={toggle} role="checkbox" aria-checked={isChecked} tabIndex={0}
                  onKeyDown={e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); } }}>
                  <IconCheckbox checked={isChecked} />
                </span>
                <span className={css.finePrint}>
                  <span className={css.acceptText} onClick={toggle}>
                    <FormattedMessage id="AuthenticationPage.termsAndConditionsAcceptPrefix" />
                  </span>
                  {' '}
                  <NamedLink className={css.termsLink} aProps={{ target: '_blank' }} name="TermsOfServicePage">
                    <FormattedMessage id="AuthenticationPage.termsAndConditionsTermsLinkText" />
                  </NamedLink>
                  {' '}
                  <FormattedMessage id="AuthenticationPage.termsAndConditionsAcceptMiddle" />
                  {' '}
                  <NamedLink className={css.termsLink} aProps={{ target: '_blank' }} name="PrivacyPolicyPage">
                    <FormattedMessage id="AuthenticationPage.termsAndConditionsPrivacyLinkText" />
                  </NamedLink>
                </span>
              </div>
              {meta.touched && meta.error && (
                <p className={css.errorMessage}>{meta.error}</p>
              )}
            </div>
          );
        }}
      </Field>
    </div>
  );
};

TermsAndConditions.propTypes = {
  intl: intlShape.isRequired,
};

export default TermsAndConditions;
